/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Controls whether the `MockPlatformLocation` class should be used
 * as the `PlatformLocation` implementation when the `BrowserTestingModule`
 * is imported.
 *
 * In v16, the value of this flag will be switched to `true` to enable
 * the `MockPlatformLocation` by default.
 */
export const ENABLE_MOCK_PLATFORM_LOCATION = false;
